import * as actions from './actions'
import * as getters from './getters'
import * as types from './types'
import { ACTIVITY_STATE } from '@/config/constants'

// 处理活动详情中关闭活动后返回列表页后刷新的问题
const state = {
  cachedActivityState: ACTIVITY_STATE.pending, // 存储活动列表当前选择的活动状态 (默认设置为进行中)
  detailActivityState: ACTIVITY_STATE.pending // 存储活动详情中的活动状态 (默认设置为进行中)
}
const mutations = {
  [types.SET_CACHED_ACTIVITY_STATE] (state, data) {
    state.cachedActivityState = data
  },
  [types.SET_DETAIL_ACTIVITY_STATE] (state, data) {
    state.detailActivityState = data
  }
}
export default {
  state,
  getters,
  actions,
  mutations
}
